module.exports = __webpack_public_path__ + "img/emailTemplate.9ed8a1fb.png";